import React from 'react';
import { ArrowRight, Phone, Mail } from 'lucide-react';

const InnerPageBanner = ({ onOpenPopup }) => {
  return (
    <section className="relative py-16 bg-gradient-to-r from-[#FF4A2A] via-[#FF6B4A] to-[#FF4A2A] overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-white rounded-full opacity-5 blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-white rounded-full opacity-5 blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          {/* Left Side - Content */}
          <div className="text-white">
            <h2 className="text-4xl font-bold mb-4">
              Need Expert Guidance?
            </h2>
            <p className="text-lg opacity-90 mb-6">
              Our team of experienced professionals is here to help you navigate the trademark registration process with confidence and ease.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={onOpenPopup}
                className="group bg-white text-[#FF4A2A] hover:bg-gray-100 px-8 py-4 rounded-xl font-semibold text-lg shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2"
              >
                Get Free Consultation
                <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </button>
            </div>
          </div>

          {/* Right Side - Contact Info Cards */}
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-white bg-opacity-10 backdrop-blur-sm border-2 border-white border-opacity-30 rounded-2xl p-6 text-white">
              <div className="bg-white bg-opacity-20 w-12 h-12 rounded-xl flex items-center justify-center mb-4">
                <Phone className="h-6 w-6" />
              </div>
              <h3 className="font-bold text-lg mb-2">Call Us</h3>
              <p className="text-sm opacity-90">+1 (888) 203 1471</p>
              <p className="text-xs opacity-75 mt-2">Mon-Fri 9AM-6PM EST</p>
            </div>
            
            <div className="bg-white bg-opacity-10 backdrop-blur-sm border-2 border-white border-opacity-30 rounded-2xl p-6 text-white">
              <div className="bg-white bg-opacity-20 w-12 h-12 rounded-xl flex items-center justify-center mb-4">
                <Mail className="h-6 w-6" />
              </div>
              <h3 className="font-bold text-lg mb-2">Email Us</h3>
              <p className="text-sm opacity-90">Info@trustedtrademarkfiler.com</p>
              <p className="text-xs opacity-75 mt-2">24/7 Support Available</p>
            </div>
            
            <div className="col-span-2 bg-white bg-opacity-10 backdrop-blur-sm border-2 border-white border-opacity-30 rounded-2xl p-6 text-center">
              <div className="text-4xl font-bold mb-2">95%</div>
              <p className="text-sm opacity-90">Success Rate</p>
              <p className="text-xs opacity-75 mt-1">Based on 500+ applications</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InnerPageBanner;